
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/gradebook/jst/PostGradesFrameDialog';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, functionType="function";


  buffer += "<div title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("post_grades_frame_dialog")
  },data:data},helper ? helper.call(depth0, "sync_grades_a16622ca", "Sync Grades", options) : helperMissing.call(depth0, "t", "sync_grades_a16622ca", "Sync Grades", options)))
    + "\" style=\"display:none;\">\n  <iframe\n    class=\"post-grades-frame\"\n    style=\"border: none; width: 100%; height: 100%;\"\n    tabindex=\"0\"\n    title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("post_grades_frame_dialog")
  },data:data},helper ? helper.call(depth0, "sync_grades_a16622ca", "Sync Grades", options) : helperMissing.call(depth0, "t", "sync_grades_a16622ca", "Sync Grades", options)))
    + "\"\n    allow=\"";
  if (helper = helpers.allowances) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.allowances); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n    data-lti-launch=\"true\"\n  >\n  </iframe>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  